export default __webpack_public_path__ + "static/media/UseCaseCard1.faa52f98.svg";